import { render, staticRenderFns } from "./TopBox.vue?vue&type=template&id=2be51dd7&scoped=true&"
import script from "./TopBox.vue?vue&type=script&lang=js&"
export * from "./TopBox.vue?vue&type=script&lang=js&"
import style0 from "./TopBox.vue?vue&type=style&index=0&id=2be51dd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be51dd7",
  null
  
)

export default component.exports